// extracted by mini-css-extract-plugin
export default {"background":"styles_background__qhwRE","aic_account_letter":"styles_aic_account_letter__Tx4ro"};